import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getOrderDetails } from "../../api/orders";

export default function OrderView() {
  const location = useLocation();
  const id = location?.state?.orderId;

  const [order, setOrder] = useState(null);
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getOrderDetails(id);

        setOrder(res?.data || res);
      } catch (err) {
        console.error(err);
      }
    };

    if (id) {
      load();
    }
  }, [id]);

  if (!order) return <h5>Loading...</h5>;

  return (
    <div className="container-fluid p-4">
      

      <div className="row g-4 mb-3">
        {/* Customer Information */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Customer Information
            </div>
            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Customer Name : </span>
                <span>{order.address?.fullName || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Mobile : </span>
                <span>{order.address?.phone || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">City : </span>
                <span>{order.address?.city || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Pincode : </span>
                <span>{order.address?.pincode || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Order Information */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Order Information
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Order ID : </span>
                <span>{order.orderId || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Order Date : </span>
                <span>{formatDate(order.createdAt)}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Status : </span>
                <span>{order.status}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Payment : </span>
                <span>{order.payment?.paymentStatus || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        {/* Product Details */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Product Details
            </div>

            <div className="card-body p-2">
              {order.items?.map((item, index) => (
                <div
                  key={index}
                  className={
                    index !== order.items.length - 1
                      ? "border-bottom pb-2 mb-1"
                      : ""
                  }
                >
                  <div className="mb-1">
                    <span className="text-muted ">Product : </span>
                    <span>{item.name}</span>
                  </div>

                  <div className="mb-1">
                    <span className="text-muted ">Variation : </span>
                    <span>{item.selections?.variantName || "N/A"}</span>
                  </div>

                  <div className="mb-1">
                    <span className="text-muted ">Quantity : </span>
                    <span>{item.quantity}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Payment Summary */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Payment Summary
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Subtotal : </span>
                <span>₹{order.subtotal || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Tax : </span>
                <span>₹{order.tax?.totalTax || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Shipping : </span>
                <span>₹{order.shipment?.shippingCharge || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Payment Method : </span>
                <span>{order.payment?.method || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Payment Status : </span>
                <span>{order.payment?.paymentStatus || "N/A"}</span>
              </div>

              <hr />

              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-bold">Total Amount :</span>
                <h5 className="mb-0 text-success">₹{order.total || 0}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4">
        {/* Shipping Details */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Shipping Details
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Dispatch Date : </span>
                <span>{formatDate(order.shipment?.dispatch_date)}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Courier : </span>
                <span>{order.shipment?.courierName || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Shipment Status : </span>
                <span>{order.shipment?.shipmentStatus || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Delivery Days : </span>
                <span>{order.shipment?.deliveryDays || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Delivery Address */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Delivery Address
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Address : </span>
                <span>
                  {order.address?.address || order.address?.addressLine1 || ""}
                  {order.address?.addressLine2
                    ? `, ${order.address.addressLine2}`
                    : ""}
                </span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">City : </span>
                <span>{order.address?.city || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">State : </span>
                <span>{order.address?.state || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted">Pincode : </span>
                <span>{order.address?.pincode || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ================= IMAGE DETAILS ================= */}
      <div className="row g-4 mt-1">
        <div className="col-12">
          <h5 className="mb-0">Verification Files</h5>
        </div>

        {/* Design Image */}
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">Design File</div>

            <div className="card-body p-2">
              {order?.designFileUrl ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center rounded border"
                  style={{
                    height: "250px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center rounded mb-3"
                    style={{
                      width: "70px",
                      height: "70px",
                      backgroundColor: "#dc3545",
                      color: "#fff",
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    ZIP
                  </div>

                  <h6 className="mb-1">Design ZIP File</h6>

                  <p className="text-muted small mb-3">
                    Download the uploaded design files
                  </p>

                  <a
                    href={order.designFileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-sm"
                    download
                  >
                    Download ZIP
                  </a>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center rounded"
                  style={{
                    height: "250px",
                    backgroundColor: "#f8f9fa",
                    color: "#6c757d",
                  }}
                >
                  No design file available
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Final Design Proof */}
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Final Design Proof
            </div>

            <div className="card-body p-2">
              {order?.finalDesignProofUrl?.length > 0 ? (
                <div className="row g-2">
                  {order.finalDesignProofUrl.map((file, index) => {
                    const fileUrl = file?.url || "";
                    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

                    const isPdf = cleanUrl.endsWith(".pdf");

                    return (
                      <div className="col-6" key={index}>
                        {fileUrl ? (
                          isPdf ? (
                            /* ================= PDF ================= */
                            <div
                              className="d-flex flex-column align-items-center justify-content-center rounded border"
                              style={{
                                height: "120px",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              <div
                                className="fw-bold text-danger mb-2"
                                style={{ fontSize: "22px" }}
                              >
                                PDF
                              </div>

                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                                className="btn btn-primary btn-sm"
                              >
                                Download PDF
                              </a>
                            </div>
                          ) : (
                            /* ================= IMAGE ================= */
                            <img
                              src={fileUrl}
                              alt={`Final Design Proof ${index + 1}`}
                              className="img-fluid rounded border w-100"
                              style={{
                                height: "120px",
                                objectFit: "contain",
                                backgroundColor: "#f8f9fa",
                              }}
                            />
                          )
                        ) : (
                          /* ================= NO FILE ================= */
                          <div
                            className="d-flex align-items-center justify-content-center rounded"
                            style={{
                              height: "120px",
                              backgroundColor: "#f8f9fa",
                              color: "#6c757d",
                              fontSize: "13px",
                            }}
                          >
                            File unavailable
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center rounded"
                  style={{
                    height: "250px",
                    backgroundColor: "#f8f9fa",
                    color: "#6c757d",
                  }}
                >
                  No final design proof available
                </div>
              )}
            </div>
          </div>
        </div>

        {/* WhatsApp Screenshot */}
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              WhatsApp Screenshot
            </div>

            <div className="card-body p-2">
              {order?.whatsappScreenshotUrl ? (
                <img
                  src={order.whatsappScreenshotUrl}
                  alt="WhatsApp Screenshot"
                  className="img-fluid rounded w-100"
                  style={{
                    height: "250px",
                    objectFit: "contain",
                    backgroundColor: "#f8f9fa",
                  }}
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center rounded"
                  style={{
                    height: "250px",
                    backgroundColor: "#f8f9fa",
                    color: "#6c757d",
                  }}
                >
                  No WhatsApp screenshot available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
